import { useQueryParams } from '@mntn-dev/app-navigation'
import { route } from '@mntn-dev/app-routing'
import { themeTextColorMap } from '@mntn-dev/ui-theme'
import { type AbstractLinkProps, cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import type React from 'react'

type LoginBoxFormFooterProps = PropsWithChildren<{
  haveAccount: string
  signUp: string
  Link: React.FC<AbstractLinkProps>
}>

const LoginBoxFormFooter = ({
  haveAccount,
  signUp,
  children,
  Link,
}: LoginBoxFormFooterProps) => {
  const queryParams = useQueryParams<'/register'>()

  return (
    <div className="mt-6">
      {children}
      <h1
        className={cn(
          `font-heading mt-6 text-center text-[24px] font-normal ${themeTextColorMap.primary}`
        )}
      >
        <span
          className={`text-[16px] font-normal ${themeTextColorMap.secondary}`}
        >
          {haveAccount}
          {/* biome-ignore lint/nursery/useConsistentCurlyBraces: <explanation> */}
        </span>{' '}
        <Link
          href={route('/register').query(queryParams).toRelativeUrl()}
          className={cn('text-[16px] font-normal', themeTextColorMap.info)}
        >
          {signUp}
        </Link>
      </h1>
    </div>
  )
}

export { LoginBoxFormFooter, type LoginBoxFormFooterProps }
